export const USER_ROUTES = {
  LIST: '/users',
  DETAIL: '/users/$id',
  CREATE: '/users/create',
  EDIT: '/users/$id/edit',
  DELETE: '/users/$id/delete',
} as const;
